import { Link } from 'react-router-dom';

const cards = [
  {
    title: 'Тренинг для руководителей',
    desc: 'Комплексная программа развития управленческих компетенций: от постановки задач до управления изменениями.',
    href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    title: 'Делегирование и постановка задач',
    desc: 'Как передавать ответственность и управлять результатом без микроменеджмента.',
    href: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach',
  },
  {
    title: 'Обратная связь и сложные разговоры',
    desc: 'Как корректировать поведение сотрудников и обсуждать сложные ситуации без конфликта.',
    href: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
  },
  {
    title: 'Командообразование',
    desc: 'Развитие взаимодействия и командной эффективности через управленческую работу и практические форматы.',
    href: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
  },
  {
    title: 'Менеджмент и лидерство',
    desc: 'Все направления развития руководителей и управленческих команд в одном хабе.',
    href: '/menedzhment-i-liderstvo',
  },
  {
    title: 'Разработка программ обучения',
    desc: 'Создание корпоративной программы обучения под задачи компании и уровень руководителей.',
    href: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya',
  },
];

export default function ReadNextSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Что изучить дальше
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Другие направления развития руководителей и управленческих команд
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((card) => (
            <Link
              key={card.href + card.title}
              to={card.href}
              className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group cursor-pointer"
            >
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-600 transition-colors">{card.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{card.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}